import { bookingInquiryApis } from '@apis/bookingInquiryApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useBookingInquiryLimits = createUseQuery(
  ['/booking-inquiry/limits/'],
  () => () => bookingInquiryApis.get('/booking-inquiry/limits/', {}).then((r) => r[200]),
);
